import React from "react";
import UscBasket from "../common/basket/UscBasket";
import CustomerSupportBanner from "./CustomerSupportBanner";
import useExtrasBuyOrReserveLabels from "../../../hooks/useExtrasBuyOrReserveLabels";
import { useUscLabel } from "../../../utils/labels";
import ServicesContainer from "./services/ServicesContainer";
import Breadcrumbs from "../common/Breadcrumbs";
import Container from "../styles/atoms/Container";
import Content from "../styles/atoms/Content";
import Sidebar from "../styles/atoms/Sidebar";
import Sections from "../styles/atoms/Sections";
import Text from "../styles/atoms/Text";
import IncludedFeeList from "./IncludedFeeList";
import * as Styles from "./ExtrasContainer.styles";
import CheckoutProcess from "./CheckoutProcess";

const ExtrasContainer = (): JSX.Element => {
    const labelKeys = useExtrasBuyOrReserveLabels();
    const extrasTitle = useUscLabel(labelKeys.extrasTitle);

    return (
        <Container variant="container-reverse">
            <Sidebar variant="basket">
                <UscBasket />
            </Sidebar>
            <Content>
                <Breadcrumbs />
                <Sections variant="main">
                    <Styles.Header>
                        <Text tag="h2" variant="h3">
                            {extrasTitle}
                        </Text>
                        <CheckoutProcess />
                    </Styles.Header>
                    <ServicesContainer />
                    <IncludedFeeList />
                    <CustomerSupportBanner />
                </Sections>
            </Content>
        </Container>
    );
};

export default ExtrasContainer;
